@if (vm$ | async; as vm) {
  @if (vm.hasBoxes) {
    <svg
      class="bounding-box-overlay"
      [class.bounding-box-overlay--visible]="vm.showOverlay"
      [style.top.px]="vm.overlayStyles.top"
      [style.left.px]="vm.overlayStyles.left"
      [style.width.px]="vm.overlayStyles.width"
      [style.height.px]="vm.overlayStyles.height"
      preserveAspectRatio="none"
      [attr.viewBox]="vm.viewBox"
    >
      <!-- SVG Mask for inverse overlay effect -->
      <defs>
        <mask [id]="vm.maskDefId">
          <!-- White background shows the overlay -->
          <rect x="0" y="0" width="100%" height="100%" fill="white" />
          <!-- Black rectangles hide the overlay (cutouts for bounding boxes) -->
          @for (box of vm.boxes; track box) {
            <rect [attr.x]="box.x" [attr.y]="box.y" [attr.width]="box.width" [attr.height]="box.height" fill="black" />
          }
        </mask>
      </defs>

      <!-- Inverse overlay - dims everything except bounding boxes -->
      <rect class="bounding-box-inverse-overlay" x="0" y="0" width="100%" height="100%" [attr.mask]="vm.maskId" />

      <!-- Bounding box outlines -->
      @for (box of vm.boxes; track box) {
        <rect
          class="bounding-box-rect"
          [attr.x]="box.x"
          [attr.y]="box.y"
          [attr.width]="box.width"
          [attr.height]="box.height"
          [attr.stroke]="box.color"
        />
      }
      <!-- Background rectangles for text labels -->
      @for (box of vm.boxes; track box) {
        <rect
          class="bounding-box-label-bg"
          [attr.x]="box.labelBgX"
          [attr.y]="box.labelBgY"
          [attr.width]="box.labelBgWidth"
          height="20"
          rx="3"
        />
      }
      <!-- Text labels on top of backgrounds -->
      @for (box of vm.boxes; track box) {
        <text class="bounding-box-text" [attr.x]="box.labelTextX" [attr.y]="box.labelTextY" [attr.fill]="box.color">
          {{ box.displayLabel }}
        </text>
      }
    </svg>
  }
}
